import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import * as Icons from '@ant-design/icons';

import FormRegistroEntradaSalida from '../formularios/FormRegistroEntradaSalida';
import insertRegistroEntradaSalida from '../../../graphql/mutations/registroEntradaSalida/insertRegistroEntradaSalida.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertRegistroEntradaSalida, {
    name: 'insertRegistroEntradaSalida',
  }),
  graphql(getUsuario)
)
class CrearRegistroEntradaSalida extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  guardarRegistroEntradaSalida = datos => {
    // console.log('ENTRE AL GUARDAR CON: ', datos);
    this.props
      .insertRegistroEntradaSalida({
        variables: {
          objRegistroEntradaSalida: {
            ...datos,
            fechaRecepcion: datos.fechaRecepcion
              ? datos.fechaRecepcion.toDate()
              : null,
            fechaDevolucion: datos.fechaDevolucion
              ? datos.fechaDevolucion.toDate()
              : null,
          },
        },
      })
      .then(respuestaRegistroEntradaSaldia => {
        if (respuestaRegistroEntradaSaldia.data) {
          notification.success({
            message: 'Nuevo Registro de Entrada y/o Salida',
            description: 'Se ha registrado con exito los datos de la registro',
          });
          this.setState(
            {
              ...this.state,
              guardado: true,
              registroEntradaSalida: datos,
            },
            () => {
              this.props.history.push('/');
            }
          );
        }
      })
      .catch(error => {
        console.log('Excepcion!!');
        console.log(error);

        Modal.error({
          title: 'Error en la creacion del registro',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>RegistroEntradaSalida</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nuevo Registro de Entrada y/o Salida
          </h2>
          <br />
          <div style={estiloContent}>
            <FormRegistroEntradaSalida
              onSubmit={this.guardarRegistroEntradaSalida}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearRegistroEntradaSalida);
